<template>
  <b-container fluid class="userGroupHeader">
    <b-row>
      <b-col cols="12" md="6">
        <b-btn class="topBtn" variant="link" @click="goTop">
          <h5 class="mb-0">測定会: {{ currentUserGroup.name }}</h5>
        </b-btn>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// import { Logger } from 'aws-amplify'
// const logger = new Logger('UserGroupHeader')

export default {
  name: 'UserGroupHeader',
  data () {
    return {
    }
  },
  computed: {
    currentUserGroup () {
      return this.$store.getters.currentUserGroup || {}
    },
    userGroupTop () {
      return '/usergroups/' + this.$store.getters.currentUserGroup.groupId + '/top'
    }
  },
  methods: {
    goTop () {
      this.$router.push(this.userGroupTop)
    }
  }
}
</script>
<style scoped>
.userGroupHeader {
  padding: 0.5em;
  margin-bottom: 0.5em;
  background-color: #003d82;
  color: #fff;
}
.topBtn {
  color: #fff;
  text-decoration: none;
}
</style>
